import { Injectable } from '@angular/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { PreviewStatus } from '../../../../core/records/entities/metadata/metadata.entity';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { ThumbailCellInterface, ThumbnailCell } from '../../components/cells/thumbnail-cell/thumbnail-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class ThumbnailColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.SMALL;
    protected readonly DISABLE_SORT: boolean = true; // Disabling because this would sort on the url, which is not very usefull

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const thumbnailCell: ThumbailCellInterface = this.getThumbnailCell(record);
            return new ThumbnailCell(thumbnailCell);
        };
    }

    private getThumbnailCell(record: ApiFragment): ThumbailCellInterface {
        return {
            imgSrc: record.getThumbnailUrl(),
            imgAlt: record.getTitle(),
            detailUrl: record.getDetailUrl(),
            previewStatus: this.getPreviewStatus(record)
        };
    }

    private getPreviewStatus(fragment: ApiFragment): PreviewStatus {
        if (fragment.hasIncompleteBrowse()) {
            return PreviewStatus.Error;
        } else if (fragment.doesNotHaveBrowse()) {
            return PreviewStatus.NoPreview;
        } else if (fragment.isProcessing() || fragment.isBrowseProcessing()) {
            return PreviewStatus.Processing;
        } else {
            return PreviewStatus.Ready;
        }
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return [
            'Administrative.RecordStatus',
            'Internal.PathToKeyframeThumb',
            'Internal.BrowseStatus',
            'Descriptive.Title',
            'Internal.FragmentId'
        ] as DottedKey[];
    }
}
